import { render, staticRenderFns } from "./SpTwoModule1.vue?vue&type=template&id=669c4d1d&scoped=true"
import script from "./SpTwoModule1.vue?vue&type=script&lang=js"
export * from "./SpTwoModule1.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule1.vue?vue&type=style&index=0&id=669c4d1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c4d1d",
  null
  
)

export default component.exports